import { Action } from 'types/Messages'

// The email statistics charts' filter options
export const EMAIL_STATISTICS_FILTERS = [Action.none, Action.blocked, Action.allowed, Action.quarantined]
